<template>
  <v-dialog
    v-model="dialog"
    max-width="1200"
  >
    <template v-slot:activator="{ on }">
      <slot
        v-bind="{
          on: on,
          loading: loading
        }"
      />
    </template>

    <v-card>
      <v-card-title>
        <v-row>
          <v-col style="text-align: center;">
            {{ $t('risk_assessment.form.title') }}
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text>
        <v-select
          outlined
          dense
          v-model="selectedAssessment"
          :items="assessments.map(a => ({ text: a.name, value: a }))"
          :label="$t('risk_assessment.form.select_risk_model')"
          :disabled="loading"
        />

        <RiskAssessment
          :key="selectedAssessment?.id || selectedAssessment?.name"
          :assessment="selectedAssessment"
          @onAssessmentScoreUpdate="onAssessmentScoreUpdate"
          @onSubmit="onSubmit"
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="closeDialog"
        >
          {{ $t('risk_assessment.form.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import RiskAssessment from '../forms/TransactionDetail3/RiskAssessment.vue'

export default {
  components: { RiskAssessment },

  props: {
    dataCy: { type: String, default: '' }
  },

  data () {
    return {
      dialog: false,
      loading: false,
      assessments: [],
      selectedAssessment: null
    }
  },

  watch: {
    dialog (newVal) {
      if (newVal) {
        this.resetForNewAssessment()
      }
    }
  },

  methods: {
    async fetchRiskAssessment () {
      try {
        this.loading = true
        const response = await this.$store.dispatch('risk/get_risk_assessment')
        this.assessments = response.data || []

        if (this.assessments.length) {
          this.selectedAssessment = this.assessments[0]
        }
      } catch (error) {
        console.error(error)
        this.$notify({
          type: 'error',
          text: this.$t('risk_assessment.form.error_load_failed')
        })
      } finally {
        this.loading = false
      }
    },

    resetForNewAssessment () {
      this.selectedAssessment = this.assessments[0] || null
    },

    onAssessmentScoreUpdate (...args) {
      this.$emit('onAssessmentScoreUpdate', ...args)
    },

    onSubmit () {
      this.closeDialog()
      this.$emit('onSubmit')
    },

    closeDialog () {
      this.dialog = false
    }
  },

  mounted () {
    this.fetchRiskAssessment()
  }
}
</script>
